<template>
    <div class="plot-contrast-list">
        <div class="header clearfix">
            <div class="left">
                <span class="name">地块对比</span>
            </div>
            <div class="operation right">
                <span @click="contraction()">
                    <i :class="plotListExpand ? 'iconfont icon-quanping' : 'iconfont icon-shouqi'"></i>
                </span>
                <span @click="close()">
                    <i class="iconfont icon-guanbi"></i>
                </span>
            </div>
        </div>
        <div class="plot" v-show="!plotListExpand">
            <div class="plot-list">
                <el-scrollbar style="height: 100%;width: 100%;">
                    <ul>
                        <li v-for="(item, index) in plotList" :key="'plotList'+index" class="clearfix">
                            <div class="index left">
                                <i class="iconfont icon-dingweiqipao-"></i>
                                <span v-html="index + 1"></span>
                            </div>
                            <div class="name left">
                                <div v-html="item.dkmc"></div>
                            </div>
                            <div class="close right" @click="remove(item)">
                                <i class="iconfont icon-guanbi"></i>
                            </div>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
            <div class="contrast-button" @click="contrast()">
                <i class="iconfont icon-wenjianfayuan"></i>
                <span>开始对比</span>
            </div>
            <!--<div @click="plotContrastList()" style="float: right;position: relative;top: -40px;left: -30px;">
                <i  class="iconfont icon-tianjiaduibi"></i>
                <div>添加对比</div>
            </div>-->
            <div class="entrance">
            <div @mouseover="entranceMouseover('plotContrastList')" @mouseleave="entranceMouseleave" @click="plotContrastList" style="position: relative;top: -50px;left: 300px;width: 60px;height: 50px;padding-top: 1px;margin-right: 5px;border-radius: 4px;">
                    <svg v-show="entranceIcon !== 'plotContrastList'" class="icon" aria-hidden="true">
                        <use xlink:href="#icon-tianjiaduibi"></use>
                    </svg>
                    <i v-show="entranceIcon === 'plotContrastList'" class="iconfont icon-tianjiaduibi"></i>
                    <div>添加对比</div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import util from '@/js/util'
// eslint-disable-next-line standard/object-curly-even-spacing
import { xzqUtils} from '@/views/class/mapmanager'
import { mapResourceApi } from '@/api/mapResourceApi'
export default {
  data() {
    return {
      plotListExpand: false,
      entranceIcon: '',
      plotList: []
    }
  },
  methods: {
    addContrast(landinfo) {
      let isExist = false
      debugger
      if (this.plotList.length >= 4) {
        util.info('地块多得已经不能再多了...')
        return
      }
      if (this.plotList.length > 0) {
        this.plotList.forEach(element => {
          if (landinfo.id === element.id) {
            isExist = true
          }
        })
      }

      if (!isExist) {
        const param = {}
        param.id = landinfo.id
        mapResourceApi.getLandInfoById(param).then(res => {
          if (res.code === 'B0001') {
            this.$utils.error('获取数据失败' + res.msg)
          } else if (res.code === '200') {
            landinfo = res.data
            landinfo.xzqmc = xzqUtils.getXZQNAME(landinfo.xzq)
            if (this.plotList.length < 4) {
              this.plotList.push(landinfo)
            }
          }
        })
      } else {
        util.info('该地块已经存在...')
      }
    },
    // 开始对比
    contrast() {
      if (this.plotList.length < 2) {
        util.info('少于两个地块不能对比...')
        return
      }
      this.$parent.plotContrastTableShow = true
      this.$parent.$refs.refplotContrastTable.contrast(this.plotList)
    },
    // 地块对比
    plotContrastList() {
      // this.$parent.addplotContrastListShow = true
      debugger
      this.$parent.$refs.refaddpdlotContrastList.open()
      // this.$parent.$refs.refaddpdlotContrastList.addContrast()
    },
    entranceMouseover(data) {
      this.entranceIcon = data
    },
    entranceMouseleave() {
      this.entranceIcon = ''
    },
    // 扩大缩小
    contraction() {
      this.plotListExpand = !this.plotListExpand
    },
    // 关闭
    close() {
      this.$parent.plotContrastListShow = false
    },
    remove(item) {
      const _this = this
      this.plotList.forEach((element, index, arr) => {
        if (item.id === element.id) {
          _this.plotList.splice(index, 1)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .plot-contrast-list{
        position: fixed;
        width: 400px;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
        right: 100px;
        top: 88px;
        .header{
            height: 44px;
            padding: 10px;
            border-bottom: 1px solid #dedede;
            .name{
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                vertical-align: middle;
            }
            .operation{
                line-height: 24px;
                i.iconfont{
                    font-size: 14px;
                    margin-left: 10px;
                    cursor: pointer;
                }
            }
        }
        .plot{
            height: 436px;
            padding: 10px 0px;
            .plot-list{
                height: calc(100% - 48px);
                ul{
                    padding: 10px 12px;
                    li{
                        background: #f4f4f4;
                        border-radius: 4px;
                        padding: 0px 10px;
                        height: 48px;
                        line-height: 48px;
                        margin-bottom: 10px;
                        text-align: left;
                        .index{
                            position: relative;
                            text-align: center;
                            i.iconfont{
                                color: #4293F4;
                                font-size: 28px;
                            }
                            span{
                                position: absolute;
                                left: 50%;
                                transform: translateX(-50%);
                                font-size: 14px;
                                color: #ffffff;
                                margin-top: -3px;
                            }
                        }
                        .name{
                            font-size: 14px;
                            font-weight: 700;
                            color: #333333;
                            margin: 0px 10px;
                            width: calc(100% - 73px);
                            div{
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                word-break: break-all;
                                width: 100%;
                            }
                        }
                        .close{
                            width: 24px;
                            height: 24px;
                            background: rgba(245,66,54,0.40);
                            line-height: 24px;
                            border-radius: 50%;
                            color: #fff;
                            cursor: pointer;
                            text-align: center;
                            margin-top: 12px;
                        }
                        &:last-child{
                            margin-bottom: 0px;
                        }
                        &:hover{
                            background: rgba(66,147,244,0.10);
                        }
                    }
                }
                ::v-deep{
                    .el-scrollbar__wrap{
                        overflow-x: hidden;
                    }
                }
            }
            .contrast-button{
                width: 160px;
                height: 48px;
                background: #2789ee;
                border-radius: 4px;
                margin: 0 auto;
                cursor: pointer;
                font-size: 18px;
                color: #ffffff;
                line-height: 48px;
                i.iconfont{
                    margin-right: 10px;
                }
            }
        }
    }
       .entrance{
                display: flex;
                justify-content: space-between;
                >div{
                    width: calc((100% - 30px) / 4);
                    margin-right: 10px;
                    background: #f8f8f8;
                    font-size: 14px;
                    color: #333333;
                    padding-top: 21px;
                    cursor: pointer;
                    .icon{
                        width: 2em;
                        height: 2em;
                    }
                    i.iconfont{
                        font-size: 28px;
                        vertical-align: -0.15em;
                        fill: currentColor;
                        overflow: hidden;
                    }
                    &:hover{
                        background: #2f80ed;
                        color: #fff;
                    }
                }
            }
</style>
